import { useState, useCallback, useMemo } from 'react';
import ErrorModal from '../components/common/modal/ErrorModal';

export const useErrorModal = () => {
  const [errorState, setErrorState] = useState({
    isOpen: false,
    statusCode: null,
    errorMessage: '',
    retryCallback: null,
  });

  const showError = useCallback((error, retryCallback = null) => {
    let statusCode = null;
    let errorMessage = 'An unexpected error occurred';

    if (error) {
      if (error.response) {
        statusCode = error.response.status;
        const data = error.response.data;
        if (data && data.error && Array.isArray(data.error)) {
          const valErrors = data.error.map(err => err.msg || err.message || JSON.stringify(err)).join(', ');
          errorMessage = `${data.message || 'Validation failed'}: ${valErrors}`;
        } else {
          errorMessage = data?.message || error.response.statusText || errorMessage;
        }
      } else if (error.status) {
        statusCode = error.status;
        const data = error.data;
        if (data && data.error && Array.isArray(data.error)) {
          const valErrors = data.error.map(err => err.msg || err.message || JSON.stringify(err)).join(', ');
          errorMessage = `${data.message || 'Validation failed'}: ${valErrors}`;
        } else {
          errorMessage = data?.message || data?.error || error.message || errorMessage;
        }
      } else if (error.message) {
        // Generic error with message
        errorMessage = error.message;
      }

      // Handle specific error messages
      if (typeof error === 'string') {
        errorMessage = error;
      }
    }

    setErrorState({
      isOpen: true,
      statusCode,
      errorMessage,
      retryCallback,
    });
  }, []);

  const closeError = useCallback(() => {
    setErrorState(prev => ({
      ...prev,
      isOpen: false,
      retryCallback: null,
    }));
  }, []);

  const handleRetry = useCallback(() => {
    if (errorState.retryCallback) {
      errorState.retryCallback();
    }
    closeError();
  }, [errorState.retryCallback, closeError]);

  const ErrorModalComponent = useMemo(() => {
    return () => (
      <ErrorModal
        isOpen={errorState.isOpen}
        onClose={closeError}
        statusCode={errorState.statusCode}
        errorMessage={errorState.errorMessage}
        onRetry={errorState.retryCallback ? handleRetry : null}
      />
    );
  }, [errorState, closeError, handleRetry]);

  return {
    showError,
    closeError,
    ErrorModal: ErrorModalComponent,
  };
};
